export const styles = {
  root: {
    maxWidth: 1096,
    backgroundColor: 'rgba(246, 246, 246,.6)',
    px: { xs: '28px', lg: '40px' },
    py: { xs: '24px', lg: '32px' },
    mb: 2,
  },
};
